import React from 'react';
import theme from './ChangeRequestDetails.module.scss';
import { CommentThreadWrapper } from '@/components/Comments/CommentThreadWrapper';

const ChangeRequestDetailsCommentTab: React.FC<{ threadId: number; buyerIncluded?: boolean }> = ({ threadId }) => (
    <div className={theme.commentsContainer}>
        <CommentThreadWrapper threadId={threadId} wrapperClassName={theme.comments} variant='flat' />
    </div>
);

export default ChangeRequestDetailsCommentTab;